module.exports = __webpack_public_path__ + "img/banner2-1@1x.01124704.jpg";